import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, unref as _unref } from "vue"

const _hoisted_1 = { class: "flex items-center justify-between" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", { class: "pt-0" }, "Add and track your member goals here")
], -1)
const _hoisted_3 = { class: "mt-8" }
const _hoisted_4 = { class: "mt-2 border rounded" }
const _hoisted_5 = { class: "py-2 capitalize" }
const _hoisted_6 = { class: "py-2 capitalize" }
const _hoisted_7 = { class: "py-2 capitalize" }
const _hoisted_8 = { class: "mt-6" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("h3", { class: "text-3xl font-medium" }, "Parent/Carer", -1)
const _hoisted_10 = { class: "mt-6" }
const _hoisted_11 = { class: "flex justify-between px-4 py-2" }
const _hoisted_12 = { class: "flex items-center space-x-4" }
const _hoisted_13 = {
  key: 0,
  class: "mt-6"
}
const _hoisted_14 = { class: "text-3xl font-medium capitalize" }
const _hoisted_15 = { class: "mt-6 border border-gray-300 divide-y divide-gray-300 rounded" }
const _hoisted_16 = { class: "w-full px-4 py-2" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("h3", { class: "text-2xl font-medium" }, "Additional", -1)
const _hoisted_18 = { class: "mt-6" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("h3", { class: "text-3xl font-medium" }, "Permissions", -1)
const _hoisted_20 = {
  class: "inline-block ml-2 text-sm text-blue-400 hover:text-blue-600",
  target: "_blank",
  href: "http://www.playincluded.com/data"
}
const _hoisted_21 = { class: "mt-4 space-y-4" }
const _hoisted_22 = { class: "flex items-center space-x-4" }
const _hoisted_23 = ["checked"]
const _hoisted_24 = { class: "flex items-center space-x-4" }
const _hoisted_25 = ["checked"]
const _hoisted_26 = { class: "mt-6" }
const _hoisted_27 = { class: "flex items-center justify-between" }
const _hoisted_28 = { class: "text-3xl font-medium capitalize" }
const _hoisted_29 = {
  key: 0,
  class: "flex py-6"
}
const _hoisted_30 = {
  key: 1,
  class: "relative flex group"
}
const _hoisted_31 = { class: "absolute px-1 m-1 mx-auto text-sm text-gray-100 transition-opacity bg-gray-800 rounded-md opacity-0 cursor-not-allowed -translate-y-1/3 w-fit bottom-4 group-hover:opacity-100" }
const _hoisted_32 = {
  key: 0,
  class: "mt-6 border border-gray-300 divide-y divide-gray-300 rounded"
}
const _hoisted_33 = { class: "w-full" }
const _hoisted_34 = { class: "mx-2 my-2 text-sm" }
const _hoisted_35 = { class: "block capitalize" }
const _hoisted_36 = { class: "block capitalize" }
const _hoisted_37 = { key: 0 }
const _hoisted_38 = { class: "block" }
const _hoisted_39 = { class: "block" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_41 = { class: "flex md:px-4 md:my-0 md:items-center" }
const _hoisted_42 = ["onClick"]
const _hoisted_43 = {
  key: 1,
  class: "flex flex-wrap gap-4 py-6"
}
const _hoisted_44 = { class: "mr-2" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#clip0_18809_4626)" }, [
    /*#__PURE__*/_createElementVNode("rect", {
      width: "16",
      height: "16",
      fill: "white",
      "fill-opacity": "0.01"
    }),
    /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#clip1_18809_4626)" }, [
      /*#__PURE__*/_createElementVNode("path", {
        d: "M0.5 9.89921C0.632608 9.89921 0.759785 9.95189 0.853553 10.0457C0.947322 10.1394 1 10.2666 1 10.3992V12.8992C1 13.1644 1.10536 13.4188 1.29289 13.6063C1.48043 13.7938 1.73478 13.8992 2 13.8992H14C14.2652 13.8992 14.5196 13.7938 14.7071 13.6063C14.8946 13.4188 15 13.1644 15 12.8992V10.3992C15 10.2666 15.0527 10.1394 15.1464 10.0457C15.2402 9.95189 15.3674 9.89921 15.5 9.89921C15.6326 9.89921 15.7598 9.95189 15.8536 10.0457C15.9473 10.1394 16 10.2666 16 10.3992V12.8992C16 13.4296 15.7893 13.9383 15.4142 14.3134C15.0391 14.6885 14.5304 14.8992 14 14.8992H2C1.46957 14.8992 0.960859 14.6885 0.585786 14.3134C0.210714 13.9383 0 13.4296 0 12.8992V10.3992C0 10.2666 0.0526784 10.1394 0.146447 10.0457C0.240215 9.95189 0.367392 9.89921 0.5 9.89921Z",
        fill: "white"
      }),
      /*#__PURE__*/_createElementVNode("path", {
        d: "M7.646 11.8532C7.69245 11.8998 7.74762 11.9367 7.80837 11.9619C7.86911 11.9871 7.93423 12.0001 8 12.0001C8.06577 12.0001 8.13089 11.9871 8.19163 11.9619C8.25238 11.9367 8.30755 11.8998 8.354 11.8532L11.354 8.85321C11.4479 8.75932 11.5006 8.63198 11.5006 8.49921C11.5006 8.36643 11.4479 8.23909 11.354 8.14521C11.2601 8.05132 11.1328 7.99857 11 7.99857C10.8672 7.99857 10.7399 8.05132 10.646 8.14521L8.5 10.2922V1.49921C8.5 1.3666 8.44732 1.23942 8.35355 1.14565C8.25979 1.05188 8.13261 0.999207 8 0.999207C7.86739 0.999207 7.74021 1.05188 7.64645 1.14565C7.55268 1.23942 7.5 1.3666 7.5 1.49921V10.2922L5.354 8.14521C5.26011 8.05132 5.13278 7.99857 5 7.99857C4.86722 7.99857 4.73989 8.05132 4.646 8.14521C4.55211 8.23909 4.49937 8.36643 4.49937 8.49921C4.49937 8.63198 4.55211 8.75932 4.646 8.85321L7.646 11.8532Z",
        fill: "white"
      })
    ])
  ]),
  /*#__PURE__*/_createElementVNode("defs", null, [
    /*#__PURE__*/_createElementVNode("clipPath", { id: "clip0_18809_4626" }, [
      /*#__PURE__*/_createElementVNode("rect", {
        width: "16",
        height: "16",
        fill: "white"
      })
    ]),
    /*#__PURE__*/_createElementVNode("clipPath", { id: "clip1_18809_4626" }, [
      /*#__PURE__*/_createElementVNode("rect", {
        width: "16",
        height: "16",
        fill: "white"
      })
    ])
  ])
], -1)

import { ref } from "vue";
import { storeToRefs } from "pinia";
import { useRoute } from "vue-router";

import ConfirmationModal from "@/components/modals/ConfirmationModal.vue";
import StudentNoteModal from "@/components/modals/StudentNoteModal.vue";
import DefaultButton from "@/components/DefaultButton.vue";
import ReadOnlyNote from "@/components/ReadOnlyNote.vue";
import RouterButton from "@/components/RouterButton.vue";
import ListRowItem from "@/components/ListRowItem.vue";
import TitleHeader from "@/components/TitleHeader.vue";
import AlertCard from "@/components/AlertCard.vue";

import api from "@/api/api";
import { Club, Student, StudentNote } from "@/types";
import { useGlobalStore, useUserStore } from "@/store";
import router from "@/router";


export default /*#__PURE__*/_defineComponent({
  __name: 'StudentPage',
  async setup(__props) {

let __temp: any, __restore: any

const route = useRoute();
const globalStore = useGlobalStore();
const { user, userIsAdmin } = storeToRefs(useUserStore());

const isDeleteModalOpen = ref(false);
const isNoteModalOpen = ref(false);
const isSavingNote = ref(false);

const club = ref({} as Club);
const student = ref({} as Student);
const notes = ref([] as StudentNote[]);

const noteModalMode = ref("create");
const selectedNote = ref({} as StudentNote | null);

const isDownloadingReport = ref(false);

const hasSmartsurveyAccess = ref(false);
hasSmartsurveyAccess.value = user.value.has_smartsurvey_access;

/** Student */
async function deleteStudent() {
  try {
    await api.clubs.removeStudentFromClub(club.value.id, student.value.id);

    globalStore.toast("SUCCESS", "Participant removed");
    return router.push({ name: "Brick_Club", params: { id: club.value.id } });
  } catch (error) {
    console.log(error);
    globalStore.toast("ERROR", "Error removing Participant");
  }
}

/** Student Notes */
function openNoteModal(mode: string, note?: StudentNote) {
  noteModalMode.value = mode;

  if (mode === "update") {
    selectedNote.value = note!;
  }

  if (mode === "create") {
    selectedNote.value = null;
  }

  isNoteModalOpen.value = true;
}

async function listStudentNotes() {
  notes.value = (await api.students.listStudentNotes(club.value.id, student.value.id)).data.notes;
}

async function createStudentNote(brick_club_date_id: number, content: string, show_parent: boolean) {
  try {
    isSavingNote.value = true;
    await api.students.createStudentNote(club.value.id, student.value.id, {
      brick_club_id: club.value.id,
      brick_club_date_id: brick_club_date_id,
      content: content,
      show_parent: show_parent,
      student_id: student.value.id,
    });

    globalStore.toast("SUCCESS", "Note created");

    await listStudentNotes();
    isNoteModalOpen.value = false;
  } catch (error) {
    console.log(error);
    globalStore.toast("ERROR", "Error adding Note");
  } finally {
    isSavingNote.value = false;
  }
}

async function editStudentNote(id: StudentNote["id"], brick_club_date_id: number, content: string, show_parent: boolean) {
  try {
    isSavingNote.value = true;
    await api.students.updateStudentNote(club.value.id, student.value.id, id, {
      brick_club_id: club.value.id,
      brick_club_date_id: brick_club_date_id,
      content: content,
      show_parent: show_parent,
      student_id: student.value.id,
    });

    globalStore.toast("SUCCESS", "Note updated");

    await listStudentNotes();
    isNoteModalOpen.value = false;
  } catch (error) {
    console.log(error);
    globalStore.toast("ERROR", "Error updating Note");
  } finally {
    isSavingNote.value = false;
  }
}

async function getChildGoalReport() {
  isDownloadingReport.value = true;
  const reportUrl = await api.goals.generateChildGoalReport(club.value.id, student.value.id);
  if (reportUrl) {
    isDownloadingReport.value = false;
    window.location.href = reportUrl.data.report;
  }
}

try {
  club.value = ((
  ([__temp,__restore] = _withAsyncContext(() => api.clubs.getClub(Number(route.params.id)))),
  __temp = await __temp,
  __restore(),
  __temp
)).data.club;
  student.value = ((
  ([__temp,__restore] = _withAsyncContext(() => api.clubs.getClubStudent(club.value.id, route.params.student_id as string))),
  __temp = await __temp,
  __restore(),
  __temp
)).data.student;
  ;(
  ([__temp,__restore] = _withAsyncContext(() => listStudentNotes())),
  await __temp,
  __restore()
);
} catch (error) {
  window.location.href = "/error";
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(StudentNoteModal, {
      isOpen: isNoteModalOpen.value,
      mode: noteModalMode.value,
      note: selectedNote.value,
      dates: club.value.dates ? club.value.dates.sort((a, b) => new Date(a.date).getTime() - new Date(b.date).getTime()) : [],
      isSavingNote: isSavingNote.value,
      onCreate: createStudentNote,
      onUpdate: editStudentNote,
      onClose: _cache[0] || (_cache[0] = ($event: any) => (isNoteModalOpen.value = false))
    }, null, 8, ["isOpen", "mode", "note", "dates", "isSavingNote"]),
    _createVNode(ConfirmationModal, {
      buttonText: "Remove Participant?",
      class: "danger",
      isOpen: isDeleteModalOpen.value,
      onDelete: deleteStudent,
      onClose: _cache[1] || (_cache[1] = ($event: any) => (isDeleteModalOpen.value = false))
    }, null, 8, ["isOpen"]),
    _createElementVNode("div", null, [
      _createVNode(TitleHeader, {
        title: _ctx.$t('view-club-participant')
      }, null, 8, ["title"])
    ]),
    (hasSmartsurveyAccess.value)
      ? (_openBlock(), _createBlock(AlertCard, {
          key: 0,
          type: "warning",
          hideIcon: "",
          class: "mt-8"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _hoisted_2,
              _createVNode(RouterButton, {
                to: { name: 'Member_Outcome', params: { member_id: student.value.id } },
                type: "primary",
                loading: false,
                disabled: false
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("member-outcomes")), 1)
                ]),
                _: 1
              }, 8, ["to"])
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(ListRowItem, {
          title: _ctx.$t('first-name-initial')
        }, {
          default: _withCtx(() => [
            _createElementVNode("p", _hoisted_5, _toDisplayString(student.value.first_name), 1)
          ]),
          _: 1
        }, 8, ["title"]),
        _createVNode(ListRowItem, {
          title: _ctx.$t('middle-name-initial')
        }, {
          default: _withCtx(() => [
            _createElementVNode("p", _hoisted_6, _toDisplayString(student.value.middle_name), 1)
          ]),
          _: 1
        }, 8, ["title"]),
        _createVNode(ListRowItem, {
          title: _ctx.$t('family-name-initial')
        }, {
          default: _withCtx(() => [
            _createElementVNode("p", _hoisted_7, _toDisplayString(student.value.last_name), 1)
          ]),
          _: 1
        }, 8, ["title"])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _createElementVNode("div", _hoisted_10, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(student.value.parents, (parent, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "mt-6 border border-gray-400 rounded",
              key: index
            }, [
              _createVNode(ListRowItem, {
                title: `${_ctx.$t('parent-carer')} - ${_ctx.$t('name')}`
              }, {
                default: _withCtx(() => [
                  _createElementVNode("p", null, _toDisplayString(parent.first_name) + " " + _toDisplayString(parent.last_name), 1)
                ]),
                _: 2
              }, 1032, ["title"]),
              _createVNode(ListRowItem, {
                title: `${_ctx.$t('parent-carer')} - ${_ctx.$t('email')}`
              }, {
                default: _withCtx(() => [
                  _createElementVNode("p", null, _toDisplayString(parent.email), 1)
                ]),
                _: 2
              }, 1032, ["title"]),
              _createVNode(ListRowItem, {
                title: `${_ctx.$t('parent-carer')} - ${_ctx.$t('added')}`
              }, {
                default: _withCtx(() => [
                  _createElementVNode("p", null, _toDisplayString(new Date(parent.meta!.pivot_created_at).toDateString()), 1)
                ]),
                _: 2
              }, 1032, ["title"]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("p", null, _toDisplayString(parent.id === student.value.primary_parent ? "Primary Carer" : ""), 1)
                ])
              ])
            ]))
          }), 128))
        ])
      ]),
      (!_unref(userIsAdmin))
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
            _createElementVNode("h2", _hoisted_14, _toDisplayString(_ctx.$t("background-notes")), 1),
            _createElementVNode("p", null, _toDisplayString(_ctx.$t("member-background-info-text")), 1),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _hoisted_17,
                _createElementVNode("p", null, _toDisplayString(_ctx.$t("member-additional-notes-text")), 1),
                _createVNode(ReadOnlyNote, {
                  content: student.value.additional_notes
                }, null, 8, ["content"])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_18, [
        _hoisted_19,
        _createElementVNode("div", null, [
          _createElementVNode("strong", null, _toDisplayString(_ctx.$t("parent-carer-subheading")), 1),
          _createElementVNode("a", _hoisted_20, _toDisplayString(_ctx.$t("what-does-this-mean")), 1)
        ]),
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("input", {
              class: "rounded",
              type: "radio",
              disabled: "",
              checked: student.value.survey_permission
            }, null, 8, _hoisted_23),
            _createElementVNode("span", null, _toDisplayString(_ctx.$t("parent-attendance-session-notes-consent")), 1)
          ]),
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("input", {
              class: "rounded",
              type: "radio",
              disabled: "",
              checked: !student.value.survey_permission
            }, null, 8, _hoisted_25),
            _createElementVNode("span", null, _toDisplayString(_ctx.$t("parent-onboarding-no-permission-facilitator")), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_26, [
        _createElementVNode("div", _hoisted_27, [
          _createElementVNode("h2", _hoisted_28, _toDisplayString(_ctx.$t("brick-club-notes")), 1),
          (_unref(user).id === club.value.facilitator_id || _unref(userIsAdmin))
            ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                (student.value.survey_permission)
                  ? (_openBlock(), _createBlock(DefaultButton, {
                      key: 0,
                      type: "primary",
                      onAction: _cache[2] || (_cache[2] = ($event: any) => (openNoteModal('create')))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("add-session-note")), 1)
                      ]),
                      _: 1
                    }))
                  : (_openBlock(), _createElementBlock("div", _hoisted_30, [
                      _createVNode(DefaultButton, {
                        type: "primary",
                        class: "cursor-not-allowed",
                        disabled: ""
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("add-session-note")), 1)
                        ]),
                        _: 1
                      }),
                      _createElementVNode("span", _hoisted_31, _toDisplayString(_ctx.$t("parent-consent-button")), 1)
                    ]))
              ]))
            : _createCommentVNode("", true)
        ]),
        (notes.value.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(notes.value, (note) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "flex flex-wrap justify-between w-full px-4 py-2 md:flex-nowrap",
                  key: note.id
                }, [
                  _createElementVNode("div", _hoisted_33, [
                    _createElementVNode("div", _hoisted_34, [
                      _createElementVNode("span", _hoisted_35, [
                        _createElementVNode("strong", null, _toDisplayString(_ctx.$t("facilitator")) + ":", 1),
                        _createTextVNode(" " + _toDisplayString(note.user.first_name) + " " + _toDisplayString(note.user.last_name), 1)
                      ]),
                      _createElementVNode("span", _hoisted_36, [
                        (note.session.brick_club)
                          ? (_openBlock(), _createElementBlock("strong", _hoisted_37, _toDisplayString(_ctx.$t("brick-club")) + ":", 1))
                          : _createCommentVNode("", true),
                        _createTextVNode(" " + _toDisplayString(note.session.brick_club?.name), 1)
                      ]),
                      _createElementVNode("span", _hoisted_38, [
                        _createElementVNode("strong", null, _toDisplayString(_ctx.$t("session")) + ":", 1),
                        _createTextVNode(" " + _toDisplayString(new Date(note.session.date).toLocaleDateString()), 1)
                      ]),
                      _createElementVNode("span", _hoisted_39, [
                        _createElementVNode("strong", null, _toDisplayString(_ctx.$t("visible-to-member-parent-carer")) + ":", 1),
                        _createTextVNode(" " + _toDisplayString(note.show_parent ? "Yes" : "No"), 1)
                      ]),
                      _createElementVNode("span", null, [
                        _createElementVNode("strong", null, _toDisplayString(_ctx.$t("created")) + ":", 1),
                        _createTextVNode(" " + _toDisplayString(new Date(note.created_at).toLocaleString()), 1)
                      ])
                    ]),
                    _hoisted_40,
                    _createVNode(ReadOnlyNote, {
                      content: note.content
                    }, null, 8, ["content"])
                  ]),
                  _createElementVNode("div", _hoisted_41, [
                    _createElementVNode("button", {
                      class: "text-blue-500",
                      onClick: ($event: any) => (openNoteModal('update', note))
                    }, "Edit", 8, _hoisted_42)
                  ])
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ]),
      (_unref(user).id === club.value.facilitator_id || _unref(userIsAdmin))
        ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
            _createVNode(RouterButton, {
              type: "primary",
              to: { name: 'Edit_Club_Participant', params: { id: club.value.id, student_id: student.value.id } }
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("edit-brick-club-participant")), 1)
              ]),
              _: 1
            }, 8, ["to"]),
            _createVNode(DefaultButton, {
              type: "danger",
              onAction: _cache[3] || (_cache[3] = ($event: any) => (isDeleteModalOpen.value = true))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("delete-brick-club-participant")), 1)
              ]),
              _: 1
            }),
            _createVNode(DefaultButton, {
              type: "primary",
              onAction: getChildGoalReport,
              loading: isDownloadingReport.value
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_44, _toDisplayString(_ctx.$t("download-report")), 1),
                _hoisted_45
              ]),
              _: 1
            }, 8, ["loading"])
          ]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}
}

})